import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

export type Feedback = { tipo: 'ok' | 'erro'; msg: string } | null;

const FeedbackBanner: React.FC<{ feedback: Feedback }> = ({ feedback }) => {
  if (!feedback) return null;
  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm ${
        feedback.tipo === 'ok'
          ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
          : 'bg-rose-50 text-rose-700 border border-rose-200'
      }`}
    >
      {feedback.tipo === 'ok' ? <CheckCircle2 className="w-4 h-4" /> : <AlertCircle className="w-4 h-4" />}
      {feedback.msg}
    </div>
  );
};

export default FeedbackBanner;
